import React from 'react';

import {
  Grid,
  Hidden,
} from '@material-ui/core';

import MainLayout from '../../common/components/MainLayout';
import LeftPanel from './LeftPanel';
import RightPanel from '../containers/RightPanel';
// import SiteSelectPanel from '../containers/SiteSelectPanel';

import classes from '../../css/getCSS';

const DashboardLayout = (props) => {
  return (
    <MainLayout
      isAuthenticated={props.isAuthenticated}
      activeLink={props.activeLink}
      dashActiveLink={props.dashActiveLink}
      rootClass={classes.dashboardLayout}
    >
      <Grid container spacing={16} className={[classes.marginTopSM, classes.marginTopXS, classes.paddingTop10MD].join(' ')}>
        <Hidden smDown>
          <Grid item md={3} xs={12} sm={12}>
            <LeftPanel user={props.user} dashActiveLink={props.dashActiveLink} />
          </Grid>
        </Hidden>
        <Grid item md={6} xs={12} sm={12}>
          {props.children}
        </Grid>
        <Grid item md={3} xs={12} sm={12}>
          <RightPanel />
          {/* <SiteSelectPanel /> */}
        </Grid>
      </Grid>
    </MainLayout>
  );
};

export default DashboardLayout;



// WEBPACK FOOTER //
// ./src/dashboard/components/DashboardLayout.js